import styled from 'styled-components'
import { Theme } from '../../../../Theme';

const Content = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 10000;
    display: flex;
    flex-direction: column;
    padding: 20px;
    
    @media (max-width: 768px) {
        padding: 10px;
    }
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background: #000;
    border-radius: 8px 8px 0 0;
    
    @media (max-width: 768px) {
        padding: 10px 15px;
    }
`;

const LogoArea = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    
    img {
        height: 50px;
        
        @media (max-width: 768px) {
            height: 35px;
        }
    }
`;

const Actions = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
`;

const DownloadButton = styled.button`
    background: #007AFF;
    border: none;
    border-radius: 6px;
    padding: 10px 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    
    &:hover {
        background: #0056b3;
        transform: scale(1.05);
    }
    
    svg {
        width: 24px;
        height: 24px;
    }
    
    @media (max-width: 768px) {
        padding: 8px 12px;
        
        svg {
            width: 20px;
            height: 20px;
        }
    }
`;

const CloseButton = styled.button`
    background: transparent;
    border: none;
    color: white;
    font-size: 30px;
    cursor: pointer;
    padding: 5px 10px;
    line-height: 1;
    transition: all 0.3s ease;
    
    &:hover {
        color: #ff4444;
        transform: scale(1.1);
    }
    
    @media (max-width: 768px) {
        font-size: 24px;
    }
`;

const InfoBar = styled.div`
    background: #1a1a1a;
    padding: 15px 20px;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: center;
    color: white;
    font-size: 14px;
    font-style: italic;
    
    span {
        color: #b0b0b0;
        
        strong {
            color: white;
            font-weight: normal;
        }
    }
    
    @media (max-width: 768px) {
        padding: 12px 15px;
        font-size: 12px;
        gap: 10px;
    }
`;

const PdfViewer = styled.div`
    flex: 1;
    background: #2a2a2a;
    border-radius: 0 0 8px 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    
    iframe {
        border: none;
        width: 100%;
        height: 100%;
    }
    
    p {
        color: white;
        font-size: 16px;
    }
`;

const LoadingMessage = styled.div`
    color: white;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

const ErrorMessage = styled.div`
    color: white;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 20px;
    
    p {
        margin: 0;
    }
    
    button {
        background: #007AFF;
        color: white;
        border: none;
        padding: 12px 30px;
        border-radius: 6px;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
            background: #0056b3;
            transform: scale(1.05);
        }
    }
`;

export const Styled = {
    Content,
    Header,
    LogoArea,
    Actions,
    DownloadButton,
    CloseButton,
    InfoBar,
    PdfViewer,
    LoadingMessage,
    ErrorMessage
}